import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';

export { default as Slider } from './BasicSlider';
export { SliderButton } from './SliderButton';
export * from './utils';
